import LayoutMain from './../../../layouts/LayoutMain.vue';
import ProgressHUD from './../../ProgressHUD/index.vue';
import GoogleMap from './../../GoogleMap/VueGoogleMap.vue';
import { Api, Toast, Helper } from './../../../services';
import ModalDialogExistingProjectSendReport from './../../Account/MyProfile/Widget/ModalDialogs/ModalDialogExistingProjectSendReport.vue';
import ProjectItem from './../GreenFund/FundProjectItem/index.vue'

export default {
  name: 'project',
  props: [],
  components: {
    LayoutMain,
    ProgressHUD,
    ModalDialogExistingProjectSendReport,
    GoogleMap,
    ProjectItem,
  },
  data() {
    return {
      project: {
        name: '',
        theme: ''
      },
      projects: null,
      validationMessage: null,
      theme: '',
      country: '',
      continent: '',
      search: {
        text: '',
        type: '',
        theme: '',
        continent: '',
        country: '',
        numberPage: 1,
        countPages: 1,
        limit: 9,
      },
      daysAll: 45,
      themes: {
        0: 'Solar',
        1: 'Wind',
        2: 'Bio mass',
        3: 'Hydro',
        4: 'Other renewables',
      },
      continents: [],
      countries: [],
      amountEarned: null,
    };
  },
   watch: {
    $route() {
      this.search.text = this.$route.query.text || ''
      this.search.theme = this.$route.query.theme || ''
      this.search.continent = this.$route.query.continent || ''
      this.search.country = this.$route.query.country || ''
      this.search.numberPage = +this.$route.query.page || 1

      this.refreshDisplayProjects()
    },
  },
  filters: {
    filterDate(value) {
      if (value) {
        var monthNames = [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December',
        ];
        var monthNamesShort = [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec',
        ];

        var date = new Date(value),
          month = monthNamesShort[date.getMonth()],
          day = date.getDate(),
          year = date.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return month + '. ' + day + ', ' + year;
      }

      return '';
    },
  },
  mounted() {
    $('.player.line iframe').css("width", '100%')
    $('.player.line iframe').css("height", '100%')
  },
  methods: {
    goToEdit() {
      this.$router.push(
        '/greenfund/edit/' + this.project._id
      )
    },
    async getFundById() {
      var response = await Api.getFundById(this.$route.params.id);
      this.project = response.data.results.project
      // this.project.videoURL = (this.project.videoURL=='') ? "<img style='height:500px;' src='"+this.project.coverImage+"'>" : this.project.videoURL
    },
    getDays(updated) {
      var date = new Date(),
          now = date.getTime()
      return (this.daysAll - Math.round((now - new Date(updated).getTime())/(1000*60*60*24)))
    },
    changeAllFilter() {
      this.theme = '';
      this.continent = '';
      this.country = '';
      this.$router.push({
        query: Object.assign({}),
      })
    },
    changeTypeFilter(type) {
      this.$router.push({
        query: Object.assign({}, this.$route.query, {
          theme: this.theme,
          continent: this.continent,
          country: this.country,
        }),
      })
    },
    changePage(numberPage) {
      this.$router.push({
        query: Object.assign({}, this.$route.query, {
          page: numberPage,
        }),
      })
    },
    searchClick() {
      this.$router.push({
        query: Object.assign({}, this.$route.query, {
          text: this.search.text,
        }),
      })
    },

    async refreshDisplayProjects() {
      try {
        // this.$refs.progress.show()
        var response = await Api.getFundProjects(this.search)

        for (var i=0; i<response.data.results.length; i++){
          response.data.results[i].numberDate = this.getDays(response.data.results[i].updated)
        }
        this.projects = response.data.results
        this.search.countPages = response.data.pagination.countPages
        console.log(response)
        function sort(a) {
            return a.sort().filter(function(item, pos, ary) {
                return !pos || item != ary[pos - 1];
            })
        }
        this.countries = sort(response.data.countries)
        var cont = response.data.continents
        for(var i=0, j=0; i<cont.length; i++)
          if(cont[i] !== ""){
             this.continents[j] = cont[i]
             j++
          }
        this.continents = sort(this.continents)

      } catch (error) {
        console.error(error)
        alert(error.message)
      } finally {
        // this.$refs.progress.hide()
      }
    },

    async sendFunds() {
     try {

      if(this.amountEarned==null || this.amountEarned =='NaN') return; 

      const isValid = await this.$validator.validateAll("formFund")
        if (!isValid) {
          Toast.error({
            toast: this.$toast,
            message: 'The entered data is not valid',
          })
          return
        }

      var formData = new FormData()
      formData.append('amountEarned', this.amountEarned)

      this.$refs.progress.show()

      var response = await Api.sendFundsProject(this.project._id, formData);
      this.project = response.data.results   

      Toast.success({
          toast: this.$toast,
          message: "Funds successfully sent",
      })
      
      await new Promise(resolve => this.$nextTick(resolve))

     } catch (error) {
        console.log(error)
        this.validationMessage = 'Something went wrong.'

        Toast.error({
          toast: this.$toast,
          title: 'Error',
          message: 'Something went wrong.',
        })
      } finally {
        this.$refs.progress.hide()
      } 
    },

  },

  async created() {

    jQuery(document).ready(function($) {

      });

    try {
      await this.getFundById();

      this.search.text = this.$route.query.text || ''
      this.search.theme = this.$route.query.theme || this.project.theme
      this.search.continent = this.$route.query.continent || ''
      this.search.country = this.$route.query.country || ''
      this.search.numberPage = +this.$route.query.page || 1
      this.search.limit = 4

      await this.refreshDisplayProjects();

      await new Promise(resolve => this.$nextTick(resolve));

      // setTimeout(function(){
      //   $('.player.line iframe').css("width", '100%')
      //   $('.player.line iframe').css("height", '100%')
      // }, 1000)


      // var owl = $('.owl-carousel');
      //   owl.owlCarousel({
      //     items:1,
      //     center: true,
      //     margin:10,
      //     merge:true,
      //     responsive:{
      //       600:{
      //         items:1
      //       }
      //     }
      //   });


    } catch (error) {
      console.error(error);
      this.validationMessage = error.message;

      Toast.error({
        toast: this.$toast,
        title: 'Error',
        message: error.message,
      });
    } finally {
      this.$refs.progress.hide();
    }



  },
};



// WEBPACK FOOTER //
// ./src/components/Project/GreenFundProjectProfile/GreenFundProjectProfile.component.js